import { withNaming } from "@bem-react/classname";
import { useLocaleContext } from "../contexts/LocaleContext";

export const createClassName = (block) =>
  withNaming({ e: "__", m: "_", v: "_" })(block);

export const createID = (elem = "") =>
  String(elem)
    .trim()
    .normalize("NFC")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\p{M}\s-]/gu, "")
    .replace(/\s+/gu, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

export const setLocaleContent = (href, sep = "/") => {
  const { localePath } = useLocaleContext();

  if (href.startsWith("http")) {
    return href;
  }

  return localePath ? `${sep}${localePath}${href}` : href;
};

export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const sortComments = (array) => {
  const sortedArray = [];

  const addCommentToArray = (index, comment) =>
    sortedArray.splice(index, 0, comment);
  const comment = (item) => addCommentToArray(0, item);
  const answer = (item) =>
    sortedArray.map((answerItem, index) => {
      if (item.parentId === answerItem.id__normalized)
        return addCommentToArray(index + 1, item);
    });

  array.map((item) =>
    item.parentId === 0 || item.parentId === null
      ? comment(item)
      : answer(item),
  );

  return sortedArray;
};

export const commentLanguage = (comment) => {
  const regex = /[а-я]/g;
  const lengthLocaleLetter = comment.match(regex);
  return lengthLocaleLetter === null ? "en" : "ru";
};

export const pageWithoutLocale = (page) => page;

// remove first and last slash if exist
export const getCommentsPage = (page) =>
  page
    .trim()
    .replace(/^\//, "")
    .replace(/\/$/, "");

export const createLinkPoints = (path) => {
  let linkString = path.slice(1, -1);
  const links = linkString.split("/");
  links.pop();
  if (links[0] !== "support") {
    links.unshift("support");
  }
  return links;
};
